import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import NumericInput from 'react-numeric-input'
import i18n from 'i18next'
import { switchValueToEstimate, switchValueToUnit } from '../helpers'
import { getPrintPreview } from './utils'
import Switch from './formElements/Switch'

const maxSafeNumber = 999999999

@observer
class Numeric extends Component {
    constructor(props) {
        super(props)

        const {
            question,
            store,
            formId,
            numberForm,
        } = props
        const { form_data } = store

        this.state = { cantAnswer: question.cantAnswer }

        this.switchPath = R.pathOr(false, ['settings', 'nonRequired'], numberForm)
            ? R.path(['settings'])(numberForm)
            : R.path(['settings', 'frontend'])(question)

        this.switch = R.pathOr(undefined, ['switch'], this.switchPath)

        const defaultSwitch = this.switchValue = this.getSwitchValue(R.pathOr(undefined, ['switch', 0], this))
        if (!numberForm) {
            if (form_data.has(question.id)) {
                this.switchValue = form_data.has(question.id) ? R.pathOr(defaultSwitch, ['metadata', 'switchValue'], form_data.get(question.id)) : defaultSwitch
            } else {
                this.switchValue = defaultSwitch
            }
        } else if (form_data.has(formId)) {
            const { data } = form_data.get(formId)
            if (data.has(question.id)) {
                this.switchValue = data.has(question.id) ? R.pathOr(defaultSwitch, ['metadata', 'isEstimate'], data.get(question.id)) ? 'Estimate' : 'Exact' : defaultSwitch
            } else {
                this.switchValue = defaultSwitch
            }
        } else {
            this.switchValue = defaultSwitch
        }
    }

    getSwitchValue = (switchValue) => {
        const { question, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        if (!switchValue) return undefined

        let localeLabel = ''

        if (switchValue[langcode]) {
            localeLabel = switchValue[langcode].text
        } else if (switchValue[defaultLocale]) {
            localeLabel = switchValue[defaultLocale].text
        } else if (switchValue[initialLocale]) {
            localeLabel = switchValue[initialLocale].text
        }
        console.log('getSwitchValue', localeLabel)
        return localeLabel
    }

    handleChange = (inputValue) => {
        const {
            question,
            store,
            formId,
            numberForm,
        } = this.props
        const canUpdate = true
        const { form_data } = store

        if (typeof inputValue !== 'number') {
            question.validator.message = i18n.t('validation.question.numeric.nonNumeric')
            question.validator.error = true
        }

        if (canUpdate) {
            const unit = switchValueToUnit(this.switchValue)
            const isEstimate = switchValueToEstimate(this.switchValue)
            if (!numberForm) {
                store.addFormResponse(question, {
                    value: inputValue,
                    formId,
                    metadata: {
                        unit,
                        isEstimate,
                        switchValue: this.switchValue,
                    },
                })
            } else {
                const newDataMap = form_data.has(formId) ? form_data.get(formId).data : new Map()
                newDataMap.set(question.id, {
                    value: inputValue,
                    metadata: {
                        isEstimate,
                        isCurrency: R.pathOr(undefined, ['settings', 'isCurrency'], numberForm),
                    },
                })
                store.addFormResponse(numberForm, {
                    data: newDataMap,
                    metadata: {
                        unit: this.props.selectedCurrency,
                        isCurrency: R.pathOr(undefined, ['settings', 'isCurrency'], numberForm),
                    },
                })
            }
        }
    }

    resetValidation = () => {
        const { question } = this.props
        question.validator.message = undefined
        question.validator.error = false
    }

    preFix = () => {
        const { question, store } = this.props
        let elem = null

        const preFix = store.prePostFix(question, 'prefix')

        if (!R.isEmpty(preFix)) {
            elem = <div style={{ marginRight: '10px' }}>{preFix}</div>
        }

        return elem
    }

    changeSwitch = (e, switchIndex = false) => {
        const {
            question,
            store,
            formId,
            numberForm,
        } = this.props
        const { form_data } = store

        const questionId = question.id
        const { checked } = e.target

        let switchValue

        if (switchIndex === false) {
            switchValue = checked
                ? this.switch[1]
                : this.switch[0]
        } else {
            switchValue = this.switch[switchIndex]
        }

        this.switchValue = this.getSwitchValue(switchValue)
        if (!numberForm) {
            if (form_data.has(questionId)) {
                const { data } = form_data.get(questionId)
                const unit = switchValueToUnit(this.switchValue)
                const isEstimate = switchValueToEstimate(this.switchValue)
                data.metadata = Object.assign({}, data.metadata, {
                    unit,
                    isEstimate,
                    switchValue: this.switchValue,
                })
                store.addFormResponse(question, data)
            }
        } else if (form_data.has(formId)) {
            const { data } = form_data.get(formId)
            if (data.has(questionId)) {
                const isEstimate = switchValueToEstimate(this.switchValue)
                data.set(question.id, {
                    value: data.get(questionId).value,
                    metadata: {
                        isEstimate,
                    },
                })
                store.addFormResponse(numberForm, {
                    data,
                    metadata: {
                        unit: this.props.selectedCurrency,
                        isCurrency: R.pathOr(undefined, ['settings', 'isCurrency'], numberForm),
                    },
                })
            }
        }
    }

    getSwitchLabel = (target) => {
        const { question } = this.props

        const index = target === 'left'
            ? 0
            : 1

        const switchValue = this.switch[index]

        return this.getSwitchValue(switchValue)
    }

    getPrePostFixLabel = (target) => {
        const { question, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        const switchValue = question.settings.frontend[target] || {}

        let localeLabel = ''
        if (switchValue[langcode]) {
            localeLabel = switchValue[langcode].text
        } else if (switchValue[defaultLocale]) {
            localeLabel = switchValue[defaultLocale].text
        } else if (switchValue[initialLocale]) {
            localeLabel = switchValue[initialLocale].text
        }

        return localeLabel
    }

    postFix = () => {
        const { question, store } = this.props
        let elem = null

        const postFix = store.prePostFix(question, 'postfix')

        if (!R.isEmpty(postFix)) {
            elem = <div style={{ marginLeft: '10px' }}>{postFix}</div>
        }

        return elem
    }

    currencySymbol = () => (
        <span style={{ marginRight: '3px' }}>
            {i18n.t(`currency.symbols.${this.props.selectedCurrency}`)}
        </span>
    )

    onKeyPress(event) {
	    if (event.which === 13 /* Enter */) {
	      event.preventDefault()
	    }
    }

    setCantAnswer = (cantAnswer) => {
        const {
            store,
            numberForm,
            question,
            formId,
        } = this.props
        const { form_data } = store

        this.setState({ cantAnswer })
        question.cantAnswer = cantAnswer

        if (!cantAnswer) return

        const questionId = question.id

        if (!numberForm) {
            if (form_data.has(questionId)) {
                form_data.delete(questionId)
            }
        } else if (form_data.has(formId)) {
            const { data } = form_data.get(formId)
            if (data.has(questionId)) {
                data.delete(questionId)
            }
        }
    }

    render() {
        const {
            question,
            store,
            formId,
            numberForm,
            validationMsg,
            index,
        } = this.props
        const { form_data } = store
        const questionId = question.id
        let data
        let value
        if (!numberForm) {
            data = form_data.has(questionId) ? form_data.get(questionId).data : {}
            value = !R.isNil(data.value) ? parseInt(data.value, 10) : null
        } else {
            data = form_data.has(formId) ? form_data.get(formId).data : new Map()
            const questionData = data.has(questionId) ? data.get(questionId) : {}
            value = !R.isNil(questionData.value) ? parseInt(questionData.value, 10) : null
        }

        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: store.displayForMobile() ? 'wrap' : 'no-wrap',
            }}
            >
                {getPrintPreview(question, store)}
                {this.preFix()}
                {R.pathOr(false, ['props', 'selectedCurrency'], this) ? this.currencySymbol() : null }
                <NumericInput
                    type="number"
                    className='numberRange'
                    id={question.id}
                    name={question.id}
                    value={value}
                    onChange={this.handleChange}
                    min={question.settings.frontend.min ? question.settings.frontend.min : null}
                    max={question.settings.frontend.max ? question.settings.frontend.max : maxSafeNumber}
                    step={question.settings.frontend.step ? question.settings.frontend.step : 1}
                    mobile={false}
                    style={false}
                    onKeyDown={this.onKeyPress}
                    onBlur={this.resetValidation}
                    disabled={question.cantAnswer}
                />
                {validationMsg}
                {this.postFix()}
                {this.switch && (
                    <Switch
                        value={this.switchValue}
                        left={this.getSwitchLabel('left')}
                        right={this.getSwitchLabel('right')}
                        onChange={this.changeSwitch}
                        question={question}
                        nonRequiredOption={R.pathOr(false, ['nonRequired'], this.switchPath)}
                        nonRequiredText={R.pathOr(false, ['nonRequiredText'], this.switchPath)}
                        noLabel={R.pathOr(false, ['settings', 'nonRequired'], numberForm) && index > 0}
                        store={store}
                        formSwitch={R.pathOr(false, ['settings', 'nonRequired'], numberForm)}
                        setCantAnswer={this.setCantAnswer}
                    />
                )}
            </div>
        )
    }
}

export default Numeric
